import { Alert, Box, Text } from '@mantine/core';
import { usePlatforma, ziuaInchiderii } from '../platforma';

// mesajul afisat in paginile in care, inainte de inchidere, se puteau face modificari
function MesajInchidere({ isProfessor, children }) {
  const { inchisa, dataInchidere } = usePlatforma();
  if (!inchisa) return null;
  const zi = ziuaInchiderii(dataInchidere);

  return (
    // fundal alb, ca mesajul sa fie lizibil si pe paginile profesorului (fundal albastru)
    <Box bg="white" mb="lg" style={{ borderRadius: 8 }}>
    <Alert color="red" title={zi ? `Platforma s-a închis pe ${zi}` : 'Platforma s-a închis'}
      style={{ textAlign: 'left' }}>
      <Text size="sm">
        {isProfessor
          ? 'Nu mai puteți răspunde la solicitări, semna cereri, solicita modificări sau modifica profilul. Puteți doar vizualiza și descărca cererile.'
          : 'Nu mai poți trimite solicitări, încărca cereri sau modifica profilul. Poți doar să descarci cererea ta și să consulți paginile de ajutor și întrebările frecvente.'}
      </Text>
      {children}
    </Alert>
    </Box>
  );
}

export default MesajInchidere;
